import styled from 'styled-components';
import LogoutIcon from '@/assets/icons/LogoutIcon';

const StyledButtonWrapper = styled.button`
  background: #f7f8f8;
  border-radius: 50%;
  display: flex;
  padding: 10px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  aspect-ratio: 1/1;
  border: none;
  cursor: pointer;
`;

export const StyledLogoutIcon = styled(LogoutIcon)<{
  $variant?: 'default' | 'danger';
  $width?: number;
  $height?: number;
}>`
  color: ${({ $variant }) => ($variant === 'danger' ? '#e74c3c' : '#000')};
  width: ${({ $width }) => ($width ? `${$width}px` : '16px')};
  height: ${({ $height }) => ($height ? `${$height}px` : '16px')};
`;

export { StyledButtonWrapper };
